'use client';

import React from 'react';
import styled, { keyframes, useTheme } from 'styled-components';
import { colors } from '../../theme/color';
import { typography } from '../../theme';

type AppLoadingScreenProps = {
  progress: number;
};

export const AppLoadingScreen: React.FC<AppLoadingScreenProps> = ({ progress }) => {
  const theme = useTheme();
  const clampedProgress = Math.min(100, Math.max(0, progress));
  const statusText = clampedProgress > 65 ? 'Hetki enää' : 'Ladataan sisältöjä';

  return (
    <PageContainer data-testid="app-loading-screen">
      <StyledLogo data-testid="app-loading-screen-logo" src={theme?.logo.white} alt="Kotipizza" />
      <ProgressBarContainer>
        <ProgressBarTrack>
          <ProgressBarFill style={{ width: `${clampedProgress}%` }} />
        </ProgressBarTrack>
        <StatusText>{statusText}</StatusText>
      </ProgressBarContainer>
    </PageContainer>
  );
};

const PageContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  background-color: ${colors.green.base};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100vw;
  height: 100vh;
  z-index: 99999;
`;

const StyledLogo = styled.img`
  width: 120px;
  margin-bottom: 48px;
`;

const ProgressBarContainer = styled.div`
  width: 60%;
  max-width: 300px;
`;

const ProgressBarTrack = styled.div`
  width: 100%;
  height: 6px;
  background-color: ${colors.white};
  border-radius: 3px;
  overflow: hidden;
`;

const shimmer = keyframes`
  0%   { background-position: 100% center; }
  100% { background-position: 0% center; }
`;

const ProgressBarFill = styled.div`
  height: 100%;
  background: linear-gradient(
    90deg,
    ${colors.darkGreen.base} 0%,
    ${colors.darkGreen.base} 28%,
    ${colors.darkGreen.lighter(40)} 50%,
    ${colors.darkGreen.base} 72%,
    ${colors.darkGreen.base} 100%
  );
  background-size: 300% 100%;
  border-radius: 3px;
  transition: width 0.3s ease;
  animation: ${shimmer} 2.4s linear infinite;
`;

const StatusText = styled(typography.ParagraphMedium)`
  color: ${colors.darkGreen.base};
  font-weight: 600;
  margin-top: 24px;
  text-align: center;
`;
